export const clipText = (text: string, letterNumber: number, ellipsis: string): string => {
  // length関数だと厳密ではないが、ピルの表示に影響ないので一旦良しとする
  if (text.length <= letterNumber) {
    return text;
  }

  const clippedText = text.slice(0, letterNumber);
  return `${clippedText}${ellipsis}`;
};
